// extracted by mini-css-extract-plugin
export default {"agentFeedWrapper":"styles_agentFeedWrapper__fG5fe","mapSwitchers":"styles_mapSwitchers__dn015"};